<template>
	<div class="product_card">
		<div id="product_card_name">{{isclass ? name.substr(0,1):name}}</div>
        <div id="product_card_name1" v-if="isclass"> {{clipTitle(name)}}</div>
        <div id="product_card_des1" v-if="isclass" >{{usage}}</div>
        <div id="product_card_des" v-if="!isclass" >{{des}}</div>
        <div id="product_card_iamge_list" v-for="(image,index) in images" :key="index">
            <!-- <ImageViewer v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></ImageViewer> -->
            <img id="product_card_iamge" v-if="!isclass" :src="image" @click="clickImg($event)">
        </div>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
        name:"productCard",
        props: {
            isclass:{
                type:Boolean,
                default: false
            },
            name: {
                type: String,
                default: ''
            },
            usage: {
                type: String,
                default: ''
            },
            des: {
                type: String,
                default: ''
            },
            images: {
                type:Array,
                default:function (){
                    return [];
                }
            }
        },
		data(){
			return{
                showImg:false,
　　　　　　      imgSrc: ''
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		mounted() {
		},
		methods:{
            clickImg(e) {
        　　　　　　this.showImg = true;
        　　　　　　// 获取当前图片地址
        　　　　　　this.imgSrc = e.currentTarget.src;
                    console.log(this.imgSrc)
                    WeixinJSBridge.invoke('imagePreview', { 
                            'current' : this.imgSrc,
                            'urls' : [this.imgSrc]
                        });
        　　　　},
            viewImg(){
    　　　　　　this.showImg = false;
    　　　　 },
            clipTitle(title){
                return title.split("（")[0]
            },
			class_click(item){
				// console.log(item.class_name);
                this.$router.push({name:'productClass',params:{class:item.class_id}});
                this.$emit('classClickBlock', item);
                
			},
			product_click(list){
                // console.log(list.product_name);
                this.$emit('productClickBlock', list);
			}
		},
		watch:{
			$route(){
				this.current_class = this.$route.params.class;
            },
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					// console.log('开始监听');
					//  console.log(newValue);
					//  console.log(oldValue);
					 this.all_date = newValue;
				 }
			}
		}
	}

</script>

<style type="text/css" scoped>
    #product_card_iamge{
        display: inline;
        text-align: center;
        margin-left: 20px;
        margin-right: 20px;
        width: 100%;
        margin: 0;
    }
    .product_card{
        margin: 20px 10px 20px 10px;
        /* border: 1px solid black; */
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0px 0px 20px rgb(230,230,230);
    }
    #product_card_name1{
        text-align: center;
        padding-top: 30px;
        padding-bottom: 10px;
        font-size: 20px;
    }
    #product_card_name{
        height: 40px;
        font-size: 20px;
        font-weight:bold;
        background: rgb(230,243,244);
        text-align: center;
        line-height: 40px;
        color: rgb(19, 136, 142);
        margin-top: -10px;
        display: inline-block;
        padding: 0 20px;
        margin-left: 20px;
        border-radius: 0 0 10px 10px;
    }
    #product_card_des{
        /* text-indent: 20px; */
        margin-top: 10px;
        line-height: 30px;
        padding-bottom: 10px;
        white-space: break-spaces;
    }
    #product_card_des1{
        /* text-indent: 20px; */
        line-height: 30px;
        padding-bottom: 10px;
        font-size: 15px;
        white-space: break-spaces;
        color: darkgray;
        /* text-align: center; */
    }
	.product_class{
		margin-top: 50px;
    }
    .class_select_list{
        background-color: rgb(1, 23, 40);
    }
    #class_name_content{
        border-top:1px solid white;
    }
    #class_name{
        color: white;
        line-height: 40px;
        /* height: 100%; */
        padding-left: 20px;
    }
    #current_class_name{
        color: white;
        line-height: 30px;
        padding-left: 30px;
    }
	ul{
		padding:0px; 
	}
	li{
		list-style-type: none;
	}

	canvas {
		display: block;
		position: absolute;
		bottom: 100px;
		right: -24px;
		z-index: 20;
		cursor: pointer;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
</style>


// WEBPACK FOOTER //
// src/components/ProductCard.vue